var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.286,
    height: 68.286,
    viewBox: "0 0 68.286 68.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1470",
    "data-name": "Group 1470",
    transform: "translate(-380 -337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M-8791.837,5529.169a4.1,4.1,0,0,1-3.815-2.606l-6.775-17.346a9.565,9.565,0,0,1-5.572-8.692v-2.805a9.561,9.561,0,0,1,8.534-9.505l15.456-1.667,19.828-6.353a4.1,4.1,0,0,1,5.153,2.652,4.14,4.14,0,0,1,.194,1.249v7.167c3.924,1,6.828,4.1,6.828,7.855s-2.9,6.855-6.828,7.855v7.167a4.1,4.1,0,0,1-4.1,4.1,4.109,4.109,0,0,1-1.244-.194l-19.7-6.311-4.769-.521,2.365,13.132a4.1,4.1,0,0,1-3.307,4.759,4.241,4.241,0,0,1-.728.064Z",
    transform: "translate(9196.463 -5131.806)",
    fill: "#fe9920",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Marketing",
    transform: "translate(380 337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M24.194,12.194c5.23,0,9.56,3.608,9.56,8.194s-4.33,8.194-9.56,8.194h0V25.851c3.821,0,6.829-2.506,6.829-5.463s-3.008-5.463-6.829-5.463h0ZM17.366,4a1.366,1.366,0,0,1,1.366,1.366h0V16.291a1.366,1.366,0,1,1-2.731,0h0V5.366A1.366,1.366,0,0,1,17.366,4Z",
    transform: "translate(27.703 6.926)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M18.389,13.115l-7.561.816a6.829,6.829,0,0,0-6.1,6.789v2.806a6.829,6.829,0,0,0,6.087,6.788l7.57.84Zm2.731-.295V31.457l5.571.618,19.962,6.369a1.366,1.366,0,0,0,1.781-1.3V7.1a1.366,1.366,0,0,0-1.782-1.3L26.693,12.192l-.27.057Zm.239,21.393,2.365,13.133a4.1,4.1,0,0,1-4.032,4.823H18.163a4.1,4.1,0,0,1-3.816-2.607L7.572,32.217A9.563,9.563,0,0,1,2,23.527V20.72a9.56,9.56,0,0,1,8.535-9.5L25.992,9.548,45.819,3.2a4.1,4.1,0,0,1,5.347,3.9V37.143a4.1,4.1,0,0,1-5.342,3.9l-19.7-6.312ZM10.836,33.064,16.891,48.57a1.366,1.366,0,0,0,1.272.869h1.528a1.366,1.366,0,0,0,1.344-1.608L18.528,33.9l-7.692-.84Z",
    transform: "translate(3.463 5.194)",
    fill: "#0c4767"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeEvent);
export default __webpack_public_path__ + "static/media/free-event.372bfbe76adefc8528e52bb4b8e86545.svg";
export { ForwardRef as ReactComponent };